import React from "react";
import { Spin } from "antd";

/**
 * Componente che mostra un indicatore di caricamento leggero durante il filtraggio
 * Questo sarà sovrapposto alla mappa senza bloccare completamente l'interfaccia
 */
const MapFilterLoader = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "rgba(255, 255, 255, 0.3)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backdropFilter: "blur(2px)", // Effetto sfocatura leggero
        zIndex: 1000, // Sopra la mappa ma sotto i popup
      }}
    >
      <div
        style={{
          background: "rgba(255, 255, 255, 0.8)",
          padding: "10px 15px",
          borderRadius: "6px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Spin size="small" />
        <span style={{ fontWeight: "500", fontSize: "14px" }}>Aggiornamento mappa...</span>
      </div>
    </div>
  );
};

export default MapFilterLoader; 